"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NuvemShop = void 0;
const react_1 = __importDefault(require("react"));
const NuvemShop = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 57 57", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M13.681 26.458a18.181 18.181 0 1 0 4.948-13.791l3.017 2.863a14.023 14.023 0 1 1-3.816 10.636l-4.149.292Z", fill: "#F8F9FE" }),
        react_1.default.createElement("path", { d: "M21.771 36.126a13.637 13.637 0 1 1 5.501-11.071l-3.119.029a10.517 10.517 0 1 0-4.243 8.539l1.861 2.503Z", fill: "#F8F9FE" })));
};
exports.NuvemShop = NuvemShop;
